import { render, staticRenderFns } from "./addlabelmanagement.vue?vue&type=template&id=6ba80290&scoped=true"
import script from "./addlabelmanagement.vue?vue&type=script&lang=js"
export * from "./addlabelmanagement.vue?vue&type=script&lang=js"
import style0 from "./addlabelmanagement.vue?vue&type=style&index=0&id=6ba80290&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba80290",
  null
  
)

export default component.exports